// extracted by mini-css-extract-plugin
module.exports = {"customerSaysRow":"TestimonialCard_customerSaysRow__R36_Q","textCol":"TestimonialCard_textCol__I0ljy","imgBox":"TestimonialCard_imgBox__b9OK6"};